import React, { useMemo } from 'react';

import { EnhancedTabs } from '@swyftx/aviary/molecules/EnhancedTabs';
import { EnhancedTab } from '@swyftx/aviary/molecules/EnhancedTabs/EnhancedTabs.types';

import { MarginOrdersType } from 'src/lib/margin/types';

type Props = {
  fullWidth?: boolean;
  tab: MarginOrdersType;
  setTab: React.Dispatch<React.SetStateAction<MarginOrdersType>>;
};

const MarginPositionsTableTabs: React.FC<Props> = ({ tab, setTab, fullWidth }) => {
  const tabs = useMemo(
    (): EnhancedTab<MarginOrdersType>[] => [
      {
        title: `Positions`,
        value: MarginOrdersType.Position,
        className: 'pb-12 pt-0',
      },
      {
        title: `Pending Orders`,
        value: MarginOrdersType.Orders,
        className: 'pb-12 pt-0',
      },
      {
        title: `History`,
        value: MarginOrdersType.History,
        className: 'pb-12 pt-0',
      },
      {
        title: `Transfers`,
        value: MarginOrdersType.Transfers,
        className: 'pb-12 pt-0',
      },
      {
        title: `Balance adjustments`,
        value: MarginOrdersType.BalanceAdjustments,
        className: 'pb-12 pt-0',
      },
    ],
    [],
  );

  return (
    <EnhancedTabs
      variant='parent'
      size='lg'
      value={tab}
      onChange={setTab}
      tabs={tabs}
      fullWidth={fullWidth}
      className='pr-8 pt-16'
    />
  );
};

export { MarginPositionsTableTabs };
